module.exports = __webpack_public_path__ + "static/flags/GQ-67beaed61b8e798a555c122b5a7bb8ed.gif";